import { createSlice } from '@reduxjs/toolkit';

export const Parametroslice = createSlice({
  name: 'parametro',
  initialState: {
    parametros_list: [],
    parametro: {},
  },
  reducers: {
    setParametrosRedux: (state, { payload }) => {
      state.parametros_list = payload;
    },
    storeParametrosRedux: (state, { payload }) => {
      state.parametro = payload;
    },
    storeParameterRedux: (state, { payload }) => {
      state.parametro = payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setParametrosRedux, storeParametrosRedux, storeParameterRedux } =
  Parametroslice.actions;
